import React from 'react';

import { IconButton, IconButtonProps, makeUclComponent } from '@fhs-legacy/universal-components';

type StoreCardButtonProps = Pick<
  IconButtonProps,
  'accessibilityLabel' | 'accessibilityRole' | 'accessibilityState' | 'icon' | 'onPress' | 'testID'
>;

export const StoreCardButton = makeUclComponent(
  ({
    accessibilityLabel,
    accessibilityRole,
    accessibilityState,
    onPress,
    icon,
    testID,
  }: StoreCardButtonProps) => {
    return (
      <IconButton
        variant="ghost"
        accessibilityLabel={accessibilityLabel}
        accessibilityRole={accessibilityRole}
        accessibilityState={accessibilityState}
        onPress={onPress}
        icon={icon}
        testID={testID}
      />
    );
  }
);
